import { render, staticRenderFns } from "./WinnersSummaryAgent.vue?vue&type=template&id=5a3c42f6&scoped=true&"
import script from "./WinnersSummaryAgent.vue?vue&type=script&lang=js&"
export * from "./WinnersSummaryAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c42f6",
  null
  
)

export default component.exports